webpackJsonp([37880801899593],{

/***/ 132:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/bike3.8ed83a68.jpg";

/***/ }),

/***/ 133:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/couch3.3f3b5e90.jpg";

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pic08.fe7e3185.jpg";

/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pic10.84b61f15.jpg";

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(22);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _pic = __webpack_require__(54);
	
	var _pic2 = _interopRequireDefault(_pic);
	
	var _pic3 = __webpack_require__(55);
	
	var _pic4 = _interopRequireDefault(_pic3);
	
	var _couch = __webpack_require__(133);
	
	var _couch2 = _interopRequireDefault(_couch);
	
	var _bike = __webpack_require__(132);
	
	var _bike2 = _interopRequireDefault(_bike);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Snippets = function Snippets(props) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Jody Smith - Snippets'
	      ),
	      _react2.default.createElement('meta', { name: 'description', content: 'About Me Page' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { id: 'main' },
	      _react2.default.createElement(
	        'section',
	        { id: 'banner', className: 'style2' },
	        _react2.default.createElement(
	          'div',
	          { className: 'inner' },
	          _react2.default.createElement(
	            'header',
	            { className: 'major' },
	            _react2.default.createElement(
	              'h1',
	              null,
	              'Snippets'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'content' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'A Small collection of javascript code snippets I find myself using frequently. These are mostly here as a reminder to myself, but feel free to use them if they are of any use to you.'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { id: 'one' },
	        _react2.default.createElement(
	          'div',
	          { className: 'inner' },
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '#unixTime' },
	              'Convert Unix Time to human readable date'
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'a',
	              { href: '#lambdaPost' },
	              'Netlify Lambda POST boiler plate with error handler and data check'
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'a',
	              { href: '#reactRedux' },
	              'React Componenet Class with Redux Store and defualt Reducer'
	            ),
	            _react2.default.createElement('br', null)
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'figure',
	              { id: 'unixTime' },
	              _react2.default.createElement(
	                'figcaption',
	                null,
	                'Convert Unix Time to human readable date'
	              ),
	              _react2.default.createElement(
	                'pre',
	                null,
	                _react2.default.createElement(
	                  'code',
	                  null,
	                  'const dateConvert =(UNIX_timestamp) => {\n    let a = new Date(UNIX_timestamp * 1000);\n    let months = [\'Jan\',\'Feb\',\'Mar\',\'Apr\',\'May\',\'Jun\',\'Jul\',\'Aug\',\'Sep\',\'Oct\',\'Nov\',\'Dec\'];\n    let year = a.getFullYear();\n    let month = months[a.getMonth()];\n    let date = a.getDate();\n    let hour = a.getHours();\n    let min = a.getMinutes();\n    let sec = a.getSeconds();\n    let time = date + \' \' + month + \' \' + year + \' \' + hour + \':\' + min + \':\' + sec ;\n    return time;\n}\n\nmodule.exports = {\n    dateConvert : dateConvert\n}\n'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'figure',
	              { id: 'lambdaPost' },
	              _react2.default.createElement(
	                'figcaption',
	                null,
	                'Netlify Lambda POST boiler plate with error handler and data check'
	              ),
	              _react2.default.createElement(
	                'pre',
	                null,
	                _react2.default.createElement(
	                  'code',
	                  null,
	                  'import dotenv from \'dotenv\'\ndotenv.config()\n\nconst statusCode = 200\nconst headers = {\n  \'Access-Control-Allow-Origin\': \'*\',\n  \'Access-Control-Allow-Headers\': \'Content-Type\',\n}\n\nexports.handler = function(event, context, callback) {\n  // basic error handler to respond back to request source if there\'s an issue\n  const handleError = (message) => {\n    callback(null, {\n      statusCode,\n      headers,\n      body: JSON.stringify({ type: message }),\n    })\n  }\n\n  // We only want to respond if this is a POST request.\n  if (event.httpMethod !== \'POST\' || !event.body) {\n    handleError(\'Please use POST\')\n    return\n  }\n\n  // Parse Post body back into JSON object\n  let data = JSON.parse(event.body)\n\n  // Verify expected data is present\n  if (\n    !data.id ||\n    !data.name \n  ) {\n    handleError(\'missing data in request\')\n    return\n  }\n\n  // echo request to verify everythign is set up, can be removed once logic is entered.\n  callback(null, {\n    statusCode,\n    headers,\n    body: event.body,\n  })\n}\n'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'figure',
	              { id: 'reactRedux' },
	              _react2.default.createElement(
	                'figcaption',
	                null,
	                'React Componenet Class with Redux Store and defualt Reducer'
	              ),
	              _react2.default.createElement(
	                'pre',
	                null,
	                _react2.default.createElement(
	                  'code',
	                  null,
	                  'import React, { Component } from \'react\'\nimport { connect } from \'react-redux\'\n\nclass ClassName extends Component {\n    \n    // this assumes a reducer with the UPDATE_STATE case.\n    updateState = (item, value) => {\n        this.props.dispatch({ type: \'UPDATE_STATE\', item: item, value: value })\n      }\n  \n    render() {\n    return (\n    <div>\n        {console.log(this.props.data)}\n        Hello World\n    </div>)\n  }\n}\nconst mapStateToProps = state => {\n  return {\n    data: state.data,\n  }\n}\n\nexport default connect(mapStateToProps)(ClassName)'
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	// import pic09 from '../assets/images/pic09.jpg'
	exports.default = Snippets;
	
	
	{
	  ;'import React, { Component } from \'react\'\nimport { connect } from \'react-redux\'\n\nclass ClassName extends Component {\n    \n    // this assumes a reducer with the UPDATE_STATE case.\n    updateState = (item, value) => {\n        this.props.dispatch({ type: \'UPDATE_STATE\', item: item, value: value })\n      }\n  \n    render() {\n    return (\n    <div>\n        {console.log(this.props.data)}\n        Hello World\n    </div>)\n  }\n}\nconst mapStateToProps = state => {\n  return {\n    data: state.data,\n  }\n}\n\nexport default connect(mapStateToProps)(ClassName)';
	}
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-snippets-js-f69c194db9af5d177b8a.js